import './index.scss';

import React from 'react';

import NewMenuIcon from '../../../assets/images/new-menu.svg';
import NewMenuMobileIcon from '../../../assets/images/new-tag-mobile.svg';
import BurgerImage from '../../../assets/images/burger.png';
import { getCategoryImage } from '../../utils/services';

const MenuItem = props => {
  const { menu, onClick } = props;
  const { name, newTag, id, image_urls } = menu;
  const imageUrl = getCategoryImage([image_urls], image_urls?.category);
  return (
    <div className="menu-item_wrapper">
      <div
        className="menu-item u_cursor_pointer"
        role="presentation"
        onClick={() => onClick(id)}
      >
        <div className="menu-item__image">
          <picture>
            <source
              srcSet={`${imageUrl['1x']}, ${imageUrl['2x']} 2x, ${imageUrl['3x']} 3x`}
              type="image/jpeg/png"
            />
            <img
              src={imageUrl['1x'] || BurgerImage}
              alt="burger"
              className="menu-item__img"
            />
          </picture>
          {newTag && (
            <>
              <img
                src={NewMenuIcon}
                alt="newmenu"
                className="menu-item__new-tag u_display_only_des"
              />
              <img
                src={NewMenuMobileIcon}
                alt="newmenu"
                className="menu-item__new-tag u_display_only_mob"
              />
            </>
          )}
        </div>
        <p className="menu-item__name">
          {name}
          {name?.toLowerCase() === 'bk cafe' && <sup>&#8482;</sup>}
        </p>
      </div>
    </div>
  );
};
export default MenuItem;
